import { Button, ButtonProps, Empty, Flex } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

interface EmptyComponentProps {
  title: string;
  buttonText?: string;
  buttonProps?: ButtonProps;
  onClick?: () => void;
}

export const EmptyTab = ({
  onClick,
  title,
  buttonText,
  buttonProps
}: EmptyComponentProps) => {
  return (
    <Flex vertical gap={16} justify="center" align="center" className="h-full">
      <Empty description={title} />

      {buttonText && onClick && (
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={onClick}
          {...buttonProps}
        >
          {buttonText}
        </Button>
      )}
    </Flex>
  );
};
